import useFetch from '../../../hooks/useFetch';
import { WarehouseQuoteRateDataForm, WarehouseQuoteRateFilters } from '../../models/WareHouseQuoteRates';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';

const useWarehouseQuoteRatesService = () => {
       const { doGet, doPost, doPut, doDelete } = useFetch();


    const [fetchingGetWarehouseQuoteRate, setFetchingGetWarehouseQuoteRate] = useState(false);
    const [fetchingUpdateWarehouseQuoteRate, setFetchingUpdateWarehouseQuoteRate] = useState(false);
    const [fetchingGetWarehouseQuoteRates, setFetchingGetWarehouseQuoteRates] = useState(false);
    const [fetchingStoreWarehouseQuoteRate, setFetchingStoreWarehouseQuoteRate] = useState(false);
    const [fetchingShowWarehouseQuoteRate, setFetchingShowWarehouseQuoteRate] = useState(false);
    const [fetchingDeleteWarehouseQuoteRate, setFetchingDeleteWarehouseQuoteRate] = useState(false);
    const [fetchingEditWarehouseQuoteRate, setFetchingEditWarehouseQuoteRate] = useState(false);
    const [fetchingCreateWarehouseQuoteRate, setFetchingCreateWarehouseQuoteRate] = useState(false);
    const getWarehouseQuoteRate = (quoteId: number, events: ServiceEvents = {}) => {
        // doGet({
        //     ...events,
        //     url: EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_RATE.replace(':quote_id', quoteId.toString()),
        //     setFetching: setFetchingGetWarehouseQuoteRate
        // });
    };

    const getAllWarehouseQuoteRatesByQuote = (
    
        quoteId: number,
        ratesFilters: WarehouseQuoteRateFilters,
        events: ServiceEvents = {}

    ) => {
      
        const queryString = Object.entries(ratesFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_QUOTES.GET_ALL_WAREHOUSE_RATES}?${queryString}`;
    
      
        doGet({
            ...events,
            url: url.replace(
                ':quote_id',
                quoteId.toString()
            ),
            setFetching: setFetchingGetWarehouseQuoteRates
        });
    };

    const storeWarehouseQuoteRate = (data: WarehouseQuoteRateDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.STORE_WAREHOUSE_RATE,
            body: data,
            setFetching: setFetchingStoreWarehouseQuoteRate
        });
    };

    const showWarehouseQuoteRate = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.SHOW_WAREHOUSE_RATE.replace(':id', id.toString()),
            setFetching: setFetchingShowWarehouseQuoteRate
        });
    };

    const deleteWarehouseQuoteRate = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.DELETE_WAREHOUSE_RATE.replace(':id', id.toString()),
            setFetching: setFetchingDeleteWarehouseQuoteRate
        });
    };

    const updateWarehouseQuoteRate = (quoteId: number, data: WarehouseQuoteRateDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.UPDATE_WAREHOUSE_RATE.replace(':quote_id', quoteId.toString()),
            body: data,
            setFetching: setFetchingUpdateWarehouseQuoteRate
        });
    };


    const createWarehouseQuoteRate = (
        quoteId: number,
        events: ServiceEvents = {}
    ) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.CREATE_WAREHOUSE_RATE.replace(':quote_id', quoteId.toString()),
            setFetching: setFetchingCreateWarehouseQuoteRate
        });
    };  
    const editWarehouseQuoteRate = (
      quoteId: number,
      events: ServiceEvents = {}
    ) => {
      doGet({
        ...events,
        url: EndPoints.WAREHOUSE_QUOTES.EDIT_WAREHOUSE_RATE.replace(
          ':id',
          quoteId.toString()
        ),
        setFetching: setFetchingEditWarehouseQuoteRate
      });
    };

    return {
        getWarehouseQuoteRate,
        updateWarehouseQuoteRate,
        getAllWarehouseQuoteRatesByQuote,
        storeWarehouseQuoteRate,
        showWarehouseQuoteRate,
        createWarehouseQuoteRate,
        editWarehouseQuoteRate,
        deleteWarehouseQuoteRate,
        fetchingGetWarehouseQuoteRate,
        fetchingUpdateWarehouseQuoteRate,
        fetchingGetWarehouseQuoteRates,
        fetchingStoreWarehouseQuoteRate,
        fetchingShowWarehouseQuoteRate,
        fetchingDeleteWarehouseQuoteRate,
        fetchingCreateWarehouseQuoteRate,
        fetchingEditWarehouseQuoteRate
      };
    };


export default useWarehouseQuoteRatesService;
